/**
 * ============================================
 * UCM - Ultra Car Manager
 * Compare Bar - Sticky bottom bar
 * © 2024 AlbaSoft Studio - All Rights Reserved
 * ============================================
 */

import { Link } from 'react-router-dom';
import { useShowroom } from './PublicLayout';
import { getImageUrl } from '../../api/client';

export default function CompareBar() {
  const { compareList, removeFromCompare, clearCompare } = useShowroom();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-2xl z-40 animate-slide-up">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Vehicles preview */}
          <div className="flex items-center gap-3 flex-1 overflow-x-auto">
            <span className="text-sm font-medium text-slate-600 shrink-0">
              Confronta ({compareList.length}/3):
            </span>
            {compareList.map((vehicle) => (
              <div
                key={vehicle.id}
                className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 rounded-lg shrink-0"
              >
                {vehicle.images?.[0] && (
                  <img
                    src={getImageUrl(vehicle.images[0])}
                    alt={`${vehicle.brand} ${vehicle.model}`}
                    className="w-10 h-7 object-cover rounded"
                  />
                )}
                <span className="text-sm font-medium text-slate-700">
                  {vehicle.brand} {vehicle.model}
                </span>
                <button
                  type="button"
                  onClick={() => removeFromCompare(vehicle.id)}
                  className="p-1 hover:bg-slate-200 rounded transition-colors"
                  aria-label={`Rimuovi ${vehicle.brand} ${vehicle.model} dal confronto`}
                  title={`Rimuovi ${vehicle.brand} ${vehicle.model} dal confronto`}
                >
                  <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))}
            {/* Empty slots */}
            {Array.from({ length: 3 - compareList.length }).map((_, i) => (
              <div
                key={`empty-${i}`}
                className="flex items-center justify-center w-32 h-10 border-2 border-dashed border-slate-300 rounded-lg text-slate-400 text-sm shrink-0"
              >
                + Aggiungi
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={clearCompare}
              className="px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
            >
              Svuota
            </button>
            <Link
              to="/vetrina/confronta"
              className="px-5 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Confronta
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
